// Generated by tooling/release-catalog. Do not hand-edit.
// Module screens remain lazy and disappear with their package.
import { assetsWebModuleContribution } from '@crest/module-assets/web-catalog';
import { assistantWebModuleContribution } from '@crest/module-assistant/web-catalog';
import { communicationsWebModuleContribution } from '@crest/module-communications/web-catalog';
import { customerPortalWebModuleContribution } from '@crest/module-customer-portal/web-catalog';
import { documentsWebModuleContribution } from '@crest/module-documents/web-catalog';
import { estimatingWebModuleContribution } from '@crest/module-estimating/web-catalog';
import { financeWebModuleContribution } from '@crest/module-finance/web-catalog';
import { insuranceClaimsWebModuleContribution } from '@crest/module-insurance-claims/web-catalog';
import { knowledgeWebModuleContribution } from '@crest/module-knowledge/web-catalog';
import { mitigationWebModuleContribution } from '@crest/module-mitigation/web-catalog';
import { procurementWebModuleContribution } from '@crest/module-procurement/web-catalog';
import { projectsWebModuleContribution } from '@crest/module-projects/web-catalog';
import { relationshipsWebModuleContribution } from '@crest/module-relationships/web-catalog';
import { reportingWebModuleContribution } from '@crest/module-reporting/web-catalog';
import { scanningMediaWebModuleContribution } from '@crest/module-scanning-media/web-catalog';
import { schedulingWebModuleContribution } from '@crest/module-scheduling/web-catalog';
import { tasksWebModuleContribution } from '@crest/module-tasks/web-catalog';
import { timesheetsWebModuleContribution } from '@crest/module-timesheets/web-catalog';
import { trainingWebModuleContribution } from '@crest/module-training/web-catalog';
import { workflowsWebModuleContribution } from '@crest/module-workflows/web-catalog';
import { workforceWebModuleContribution } from '@crest/module-workforce/web-catalog';

export const platformWebReleaseCatalogHash = 'a9ff4a90bbb2ef6ea4effe9535c650a0db5fe84bb49edb6cd77750050afaf204' as const;

export const platformWebInstalledModuleContributions = [
  assetsWebModuleContribution,
  assistantWebModuleContribution,
  communicationsWebModuleContribution,
  customerPortalWebModuleContribution,
  documentsWebModuleContribution,
  estimatingWebModuleContribution,
  financeWebModuleContribution,
  insuranceClaimsWebModuleContribution,
  knowledgeWebModuleContribution,
  mitigationWebModuleContribution,
  procurementWebModuleContribution,
  projectsWebModuleContribution,
  relationshipsWebModuleContribution,
  reportingWebModuleContribution,
  scanningMediaWebModuleContribution,
  schedulingWebModuleContribution,
  tasksWebModuleContribution,
  timesheetsWebModuleContribution,
  trainingWebModuleContribution,
  workflowsWebModuleContribution,
  workforceWebModuleContribution,
] as const;
